import {Component, Input, OnInit} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import {PensionProductLegendModel} from '../../products-route/pension-products-family-route/pension-product-legend-model';
import {PensionProductPreviewModel} from '../pension-product-preview-model';
import {PensionProductsPreviewService} from '../pension-products-preview.service';
import {isSameRef} from '../../service/utils';
import {InsuranceSubscription} from '@lifeislife/lifeislife-domain';
import {PensionAmountField} from '../../products-route/pension-products-family-route/pension-amount-field';
import {ContactPensionProductsPreviewModel} from '../contact-pension-products-preview-model';
import {Color} from '@swimlane/ngx-charts/lib/utils/color-sets';
import {ScaleType} from '@swimlane/ngx-charts';

@Component({
  selector: 'cf-pension-reserve-charts',
  templateUrl: './pension-reserve-charts.component.html',
  styleUrls: ['./pension-reserve-charts.component.scss'],
})
export class PensionReserveChartsComponent implements OnInit {

  @Input()
  set model(value: ContactPensionProductsPreviewModel) {
    this.initModel(value);
  }

  @Input()
  showCharts = true;
  @Input()
  showLegend = true;
  @Input()
  showLegalStrings = true;

  produtsModel: ContactPensionProductsPreviewModel;
  legendModel: PensionProductLegendModel[];
  // Selection
  selectedInsurance: InsuranceSubscription | null = null;
  selectedAmountField: PensionAmountField | null = null;
  PensionAmountField = PensionAmountField;

  // Charts model for charts component
  estimatedReservebreackdownModel: any[];
  vestedReserveBreakdownModel: any[];
  estimatedIncomeBreakdownModel: any[];


  colorScheme: Color = {
    domain: [
      '#2B4A9F', '#4275FF',
      '#6f7eb8', '#424e66',
      '#504d4d',
    ],
    name: 'scheme',
    selectable: true,
    group: ScaleType.Quantile
  };

  constructor(
    private pensionProductModelService: PensionProductsPreviewService,
  ) {
  }

  ngOnInit(): void {
  }

  onPieActivate(event: any, type: PensionAmountField) {
    const eventName: string = event.value.name as string;
    if (this.produtsModel == null || this.produtsModel.products == null
      || this.legendModel == null) {
      return;
    }
    const chartItem = this.produtsModel.products.find(p => p.subscriptionName === eventName);

    let legendItem;
    if (chartItem && chartItem.insuranceSubscriptionRef) {
      legendItem = this.legendModel.find(i => i != null
        && i.insuranceSubscription != null
        && isSameRef(i.insuranceSubscription, chartItem.insuranceSubscriptionRef),
      );
    } else {
      legendItem = null;
    }
    if (legendItem) {
      this.selectedInsurance = legendItem.insuranceSubscription;
      this.selectedAmountField = type;
    } else {
      this.selectedInsurance = null;
      this.selectedAmountField = null;
    }
  }

  onPieDeactivate(event: any, type: PensionAmountField) {
    this.selectedAmountField = null;
    this.selectedInsurance = null;
  }


  private initModel(value: ContactPensionProductsPreviewModel) {
    this.produtsModel = value;

    if (value == null) {
      this.legendModel = null;
      this.estimatedIncomeBreakdownModel = null;
      this.estimatedReservebreackdownModel = null;
      this.vestedReserveBreakdownModel = null;
    } else {
      this.estimatedReservebreackdownModel = this.pensionProductModelService.createEstimatedPensioNAmountBreakdownChartModel(value);
      this.estimatedIncomeBreakdownModel = this.pensionProductModelService.createEstimatedIncomeOnTwentyYearChartModel(value);
      this.vestedReserveBreakdownModel = this.pensionProductModelService.createVestedReserveBreakDownChartModel(value);
      this.fetchSubscriptionModels$(value.products)
        .subscribe(l => this.legendModel = l);
    }
  }


  private fetchSubscriptionModels$(models: PensionProductPreviewModel[]): Observable<PensionProductLegendModel[]> {
    const modelsPerId: { id: number, model: PensionProductPreviewModel }[] = models
      .map(
        m => {
          return {
            id: m.insuranceSubscriptionRef == null ? null : m.insuranceSubscriptionRef.id,
            model: m,
          };
        },
      );
    const sortedModels: PensionProductPreviewModel[] = modelsPerId
      .sort((a, b) => a.id < b.id ? -1 : 1)
      .map(m => m.model);
    const task$s = [];
    for (let i = 0; i < sortedModels.length; i++) {
      const model = sortedModels[i];
      const color = this.colorScheme.domain[i % this.colorScheme.domain.length];
      const task$ = this.pensionProductModelService.createSubscriptionLegendModel$(model, color);
      task$s.push(task$);
    }
    return task$s.length === 0 ? of([]) : forkJoin(task$s);
  }

}
